module.exports = __webpack_public_path__ + "img/es.8413cd53.svg";